import React, { Component } from "react";
import { connect } from "react-redux";
import ViewDocument from "./ViewDocument";
import { SlBusyIndicator } from "./editors";
import {documentActions} from "../_actions";


class ViewDocument_NewTab extends Component {
    constructor(props) {
        super(props)

        this.state = {
            documentData: {},
            documentImg: [],
            loadingDocuments: false
        }
    }

    componentDidMount() {
        let documentData = {};
        documentData = JSON.parse(sessionStorage.getItem("documentData"));
        if (documentData.hasOwnProperty("id")) {
            this.props.actions.getFileByImgId(documentData);
            this.setState({
                documentData
            })
        }
    }

    render() {
        const { documentData } = this.state;
        const { documentImg } = this.props;
        return (
            <div>
                {this.props.imgLoading ?
                    <SlBusyIndicator visibile={this.props.imgLoading} />
                :
                    <div className="view-document-new-tab-container"><ViewDocument document={documentData} documentImage={documentImg} /></div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        imgLoading: state.documents.imgLoading,
        documentImg: state.documents.documentImg,
        fetchImgError: state.documents.fetchImgError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: {
            getFileByImgId: (data) => {
                dispatch(documentActions.getFileImgById(data))
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewDocument_NewTab);


// WEBPACK FOOTER //
// ./src/components/ViewDocument_NewTab.jsx